import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './assets/css/print.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import { ThemeProvider } from '@mui/material/styles';
//import theme_bak from "./theme";
import store from "./store"
import { Provider } from "react-redux";
import { CookiesProvider } from 'react-cookie';
import TagManager from 'react-gtm-module'

if (process.env.REACT_APP_GTAG) {
    try {
        TagManager.initialize({ gtmId: process.env.REACT_APP_GTAG })
    } catch (error) {
        console.error('TagManager', error)
    }
}


ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <CookiesProvider>
                <App />
            </CookiesProvider>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
)
    ;
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
